import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getAcceptingAssessment, saveAcceptingAssessment, updateAcceptingAssessment } from "./../../../actions/AppraisalCycleAction";

class aparAcceptingManagerForm2 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      hasExistingAssessment: false,
      isSubmitted: false,
      consistentWithPenPicture: '',
      agreeWithRemarks: '',
      differenceOfOpinion: '',
      overallGrade: '',
      reviewingOverallGrade: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Acceptance Authority - Acceptance - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, kpiReportId });

    if (kpiReportId) {
      this.loadExistingData(kpiReportId);
    }
  }

  loadExistingData = (kpiReportId: any) => {
    this.setState({ showLoader: true });
    getAcceptingAssessment({ kpiReportId }).then((res: any) => {
      const data = res?.result || res;
      this.setState((prev: any) => ({ employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, data || {}) } }));
      const reviewingGrade = data?.reviewingOverallGrade !== undefined && data?.reviewingOverallGrade !== null
        ? String(data.reviewingOverallGrade)
        : '';
      const acceptingData = data?.acceptingAssessment || data;
      if (acceptingData && (acceptingData.id || acceptingData.kpi_report_id)) {
        this.setState({
          hasExistingAssessment: true,
          isSubmitted: !!acceptingData.is_submitted,
          consistentWithPenPicture: acceptingData.is_grade_consistent !== undefined
            ? (acceptingData.is_grade_consistent ? 'Yes' : 'No')
            : '',
          agreeWithRemarks: acceptingData.agree_with_authorities !== undefined
            ? (acceptingData.agree_with_authorities ? 'Yes' : 'No')
            : '',
          differenceOfOpinion: acceptingData.difference_details || '',
          overallGrade: acceptingData.overall_grade !== undefined && acceptingData.overall_grade !== null
            ? String(acceptingData.overall_grade)
            : reviewingGrade,
          reviewingOverallGrade: reviewingGrade,
        });
      } else {
        this.setState({
          reviewingOverallGrade: reviewingGrade,
          overallGrade: reviewingGrade,
        });
      }
      this.setState({ showLoader: false });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  validateForm = () => {
    const { consistentWithPenPicture, agreeWithRemarks } = this.state;
    if (!consistentWithPenPicture) {
      alert("Please select whether the overall grade is consistent with the pen picture.");
      return false;
    }
    if (!agreeWithRemarks) {
      alert("Please select whether you agree with the remarks.");
      return false;
    }
    const grade = parseFloat(this.state.overallGrade);
    if (isNaN(grade) || grade < 0 || grade > 100) {
      alert("Please enter a valid overall grade between 0 and 100.");
      return false;
    }
    return true;
  };

  callAcceptingApi = (isSubmit: boolean, callback: () => void) => {
    const { kpiReportId, hasExistingAssessment, consistentWithPenPicture, agreeWithRemarks, differenceOfOpinion, overallGrade } = this.state;

    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }

    this.setState({ showLoader: true });

    const payload = {
      kpiReportId,
      isGradeConsistent: consistentWithPenPicture === 'Yes',
      agreeWithAuthorities: agreeWithRemarks === 'Yes',
      differenceDetails: differenceOfOpinion,
      overallGrade: parseFloat(overallGrade) || 0,
      isSubmit,
    };

    const apiCall = hasExistingAssessment
      ? updateAcceptingAssessment(payload)
      : saveAcceptingAssessment(payload);

    apiCall.then(() => {
      this.setState({ showLoader: false, hasExistingAssessment: true });
      callback();
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callAcceptingApi(false, () => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    if (!window.confirm('Are you sure you want to submit the acceptance? This action cannot be undone.')) return;

    this.callAcceptingApi(true, () => {
      this.setState({ isSubmitted: true });
      alert("Acceptance submitted successfully!");
      this.props.history.push(CONSTANT.component.acceptingManagerReport.url);
    });
  };

  render() {
    const { showLoader, employeeData, consistentWithPenPicture, agreeWithRemarks, differenceOfOpinion, overallGrade, reviewingOverallGrade, isSubmitted } = this.state;

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Acceptance Authority - Acceptance</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="accepting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This acceptance has been submitted and is now view-only.
                  </div>
                )}

                {!showLoader && (
                  <div>
                    {/* Question 1 */}
                    <div className="mb-4">
                      <label className="form-label">
                        <strong>1.</strong> Is the overall grade given by the Reporting/Reviewing Authority consistent with the pen picture given by them?
                      </label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="consistentWithPenPicture"
                            id="consistentYes"
                            value="Yes"
                            checked={consistentWithPenPicture === "Yes"}
                            onChange={(e) => this.setState({ consistentWithPenPicture: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="consistentYes">Yes</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="consistentWithPenPicture"
                            id="consistentNo"
                            value="No"
                            checked={consistentWithPenPicture === "No"}
                            onChange={(e) => this.setState({ consistentWithPenPicture: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="consistentNo">No</label>
                        </div>
                      </div>
                    </div>

                    {/* Question 2 */}
                    <div className="mb-4">
                      <label className="form-label">
                        <strong>2.</strong> Do you agree with the remarks of the Reporting/Reviewing Authorities?
                      </label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithRemarks"
                            id="agreeRemarksYes"
                            value="Yes"
                            checked={agreeWithRemarks === "Yes"}
                            onChange={(e) => this.setState({ agreeWithRemarks: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="agreeRemarksYes">Yes</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="agreeWithRemarks"
                            id="agreeRemarksNo"
                            value="No"
                            checked={agreeWithRemarks === "No"}
                            onChange={(e) => this.setState({ agreeWithRemarks: e.target.value })}
                            disabled={isSubmitted}
                          />
                          <label className="form-check-label" htmlFor="agreeRemarksNo">No</label>
                        </div>
                      </div>
                    </div>

                    {/* Question 3 */}
                    <div className="mb-4">
                      <label className="form-label">
                        <strong>3.</strong> In case of difference of opinion, details thereof and reasons for the same may be given.
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={differenceOfOpinion}
                        onChange={(e) => this.setState({ differenceOfOpinion: e.target.value })}
                        placeholder="Enter details..."
                        disabled={isSubmitted}
                      />
                    </div>

                    {/* Reviewing Manager Overall Grade (Read-only) */}
                    {reviewingOverallGrade !== '' && (
                      <div className="mb-4">
                        <label className="form-label">
                          <strong>4.</strong> Overall grade given by Reviewing Authority (on a scale of 0 – 100)
                        </label>
                        <div className="d-flex align-items-center mt-2">
                          <input
                            type="text"
                            className="form-control"
                            style={{ maxWidth: '200px', backgroundColor: '#e9ecef' }}
                            value={parseFloat(reviewingOverallGrade).toFixed(2)}
                            readOnly
                            disabled
                          />
                          <span className="ml-2 text-muted">/ 100</span>
                        </div>
                      </div>
                    )}

                    {/* Accepting Manager Overall Grade */}
                    <div className="mb-4">
                      <label className="form-label">
                        <strong>{reviewingOverallGrade !== '' ? '5' : '4'}.</strong> Overall grade by Acceptance Authority on a scale of 0 – 100
                      </label>
                      <p className="text-muted small mb-2">
                        Grades should be assigned on a scale of 0-100, with 100 referring to the best grade and 0 to the lowest grade.
                        {reviewingOverallGrade !== '' && ' You may update the grade or keep the reviewing authority\'s grade.'}
                      </p>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        className="form-control"
                        style={{ maxWidth: '200px' }}
                        value={overallGrade}
                        onChange={(e) => {
                          let val = e.target.value;
                          const num = parseFloat(val);
                          if (val !== '' && !isNaN(num)) {
                            if (num > 100) val = '100';
                            if (num < 0) val = '0';
                          }
                          this.setState({ overallGrade: val });
                        }}
                        placeholder="0.00"
                        disabled={isSubmitted}
                      />
                    </div>

                    {/* Submit */}
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                          <i className="fa fa-paper-plane mr-1" />{showLoader ? "Submitting..." : "Submit Acceptance"}
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparAcceptingManagerForm2);
